import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PutCrecaAccountsRequestModel, PutCrecaAccountsResponseModel } from "@/features/accounts/creca/services/put-accounts-model";

export class PutCrecaAccountsApi {
  /**
   * クレカ更新API
   */
  public putCrecaAccounts = async (
    param: PutCrecaAccountsRequestModel
  ): Promise<PutCrecaAccountsResponseModel> => {
    const path = `/api/crecaaccounts/crecas`;
    const res = await ApiClient.instance.put<PutCrecaAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
